'use strict';

const dateTimeFormat = (options) => (date, locale) => {
    const dateTime = new Intl.DateTimeFormat(locale, options);
    return dateTime.format(date);
};
const formatWeekday = dateTimeFormat({ weekday: 'narrow' });
const formatMonth = dateTimeFormat({ month: 'long', year: 'numeric' });
const isDateValid = (date) => date instanceof Date && date.toString() !== 'Invalid Date';
const parseDate = (pattern, { isUTC = true } = {}) => (value) => {
    const isValueParseable = value.length === pattern.length;
    if (!isValueParseable)
        return null;
    const getPart = (part) => value.substr(pattern.indexOf(part), part.length);
    const [day, month, year] = [getPart('DD'), getPart('MM'), getPart('YYYY')].map(part => parseInt(part, 10));
    const date = isUTC ? new Date(Date.UTC(year, month - 1, day)) : new Date(year, month - 1, day);
    return isDateValid(date) ? date : null;
};
const padZero = (n) => (n < 10 ? `0${n}` : String(n));
const formatDate = (pattern, { isUTC = true } = {}) => (date) => {
    if (!date)
        return '';
    const day = isUTC ? date.getUTCDate() : date.getDate();
    const month = isUTC ? date.getUTCMonth() : date.getMonth();
    const year = isUTC ? date.getUTCFullYear() : date.getFullYear();
    return pattern
        .replace('DD', padZero(day))
        .replace('MM', padZero(month + 1))
        .replace('YYYY', String(year));
};
const startOfMonth = (date, { isUTC = true } = {}) => {
    const start = new Date(date);
    isUTC ? start.setUTCDate(1) : start.setDate(1);
    return start;
};
const addMonths = (n, { isUTC = true } = {}) => (date) => {
    const next = new Date(date);
    if (isUTC)
        next.setUTCMonth(date.getUTCMonth() + n);
    else
        next.setMonth(date.getMonth() + n);
    return next;
};
const toYYYMMDD = (date) => date.toISOString().slice(0, 10);
const isSameDay = (comparator) => (date) => toYYYMMDD(comparator) === toYYYMMDD(date);
const isAfterDay = (comparator) => (date) => toYYYMMDD(comparator).localeCompare(toYYYMMDD(date)) < 0;
const isSameOrAfterDay = (comparator) => (date) => isSameDay(comparator)(date) || isAfterDay(comparator)(date);
const isBeforeDay = (comparator) => (date) => !isSameOrAfterDay(comparator)(date);
const isSameYear = (comparator) => (date) => comparator.getFullYear() === date.getFullYear();
const isSameMonth = (comparator) => (date) => isSameYear(comparator)(date) && comparator.getMonth() === date.getMonth();
// The following utc functions are NOT converters, they are a way to treat a date _as if_ it was UTC,
// making the bridge for library not using UTC dates.
const toUTC = (date) => new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
const fromUTC = (date) => new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

exports.addMonths = addMonths;
exports.formatDate = formatDate;
exports.formatMonth = formatMonth;
exports.formatWeekday = formatWeekday;
exports.fromUTC = fromUTC;
exports.isAfterDay = isAfterDay;
exports.isBeforeDay = isBeforeDay;
exports.isDateValid = isDateValid;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isSameOrAfterDay = isSameOrAfterDay;
exports.isSameYear = isSameYear;
exports.parseDate = parseDate;
exports.startOfMonth = startOfMonth;
exports.toUTC = toUTC;
exports.toYYYMMDD = toYYYMMDD;
//# sourceMappingURL=date.js.map
